import { isKnownXpensCategory } from "./xpens-categories";

/**
 * XPEN-3192 / XPEN-3183-009 (D4): a category's link (maps_from_verify_category)
 * is stale when it points at a standard XPENS category that is no longer
 * among the active sixteen. Detected at runtime against the live category
 * list, not a stored "was this ever valid" flag — this stays correct as the
 * sixteen change and needs no migration output.
 *
 * The link can hold more than one format on live data: the linkage picker
 * writes the display `name_en` since XPEN-3251 (it wrote the `code` between
 * XPEN-3187 and XPEN-3251 — that format never matched the backend's
 * exact-match lookup, so every hand-made link silently did nothing; XPEN-3251
 * fixed the picker and repaired the already-saved rows), and
 * patch_xpen_3189_xpens_categories_v2.py writes the full `name_en` when it
 * repairs an existing link during a migration. isKnownXpensCategory
 * recognizes either format, so an unrepaired legacy `code` still resolves.
 *
 * @param {string | null | undefined} mapsFromVerifyCategory - the row's link, a
 *   standard category `code` or name (or null/absent — no link is normal, not a fault).
 * @param {Array<{code: string, name_en: string, name_fr: string}> | null | undefined} xpensCategories -
 *   the currently active standard categories (`data.xpensCategories`). Passed
 *   explicitly rather than read from the MobX store so this stays a pure,
 *   easily testable function.
 * @returns {boolean}
 */
export function isImputationLinkStale(mapsFromVerifyCategory, xpensCategories) {
  if (!mapsFromVerifyCategory) return false;
  // Fails safe: if the live list hasn't loaded yet, never claim a link is
  // stale — a false warning is worse than a brief, silent no-warning window.
  if (!Array.isArray(xpensCategories) || xpensCategories.length === 0) return false;
  return !isKnownXpensCategory(mapsFromVerifyCategory, xpensCategories);
}
